import {
  abortNavigation,
  defineNuxtRouteMiddleware,
  navigateTo,
  useRuntimeConfig,
} from '#imports'

export default defineNuxtRouteMiddleware((to, from) => {
  const isVisitingCurrentPath = from.fullPath === to.fullPath

  const { FF_ENABLE_NEW_EXTERNAL_NAVIGATION } = useRuntimeConfig().public

  if (
    // skip middleware on server
    import.meta.server ||
    // skip middleware on initial client load
    isVisitingCurrentPath ||
    // skip middleware in local dev, Ingress does not exists locally
    process.dev
  ) {
    return
  }

  if (!FF_ENABLE_NEW_EXTERNAL_NAVIGATION) {
    if (typeof to.meta?.disableClientSideNavigation === 'function') {
      const isClientSideNavigationDisabled =
        to.meta.disableClientSideNavigation({
          to,
          from,
        })

      if (isClientSideNavigationDisabled) {
        window.location.assign(to.fullPath)

        // eslint-disable-next-line consistent-return
        return abortNavigation()
      }
    }
  }

  if (FF_ENABLE_NEW_EXTERNAL_NAVIGATION) {
    const isClientSideNavigationDisabled =
      typeof to.meta?.disableClientSideNavigation === 'function' &&
      to.meta.disableClientSideNavigation({ to, from })

    // If the client-side navigation has been disabled, it triggers an external
    // navigation
    if (isClientSideNavigationDisabled) {
      // eslint-disable-next-line consistent-return
      return navigateTo(to.fullPath, { external: true })
    }

    // If to.matched is an empty array it means the target route is not in the
    // current app. Therefore it triggers an external navigation.
    if (to.matched.length === 0) {
      // eslint-disable-next-line consistent-return
      return navigateTo(to.fullPath, { external: true })
    }
  }
})
